import { render } from "./index.vue?vue&type=template&id=20c5c030"
import script from "./blog-content-tts.js?vue&type=script&lang=js&external"
export * from "./blog-content-tts.js?vue&type=script&lang=js&external"

import "./blog-content-tts.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__